import React from 'react';
import _ from 'lodash';
import { Grid, makeStyles } from '@material-ui/core';
import SiteCard from './SiteCard';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  container: {
    maxHeight: 800,
    overflowY: 'scroll'
  },
  title: {
    fontWeight: 500
  }
}));

function Sites(props) {
  const classes = useStyles();
  const { business, sites } = props;
  const orderedSites = _.orderBy(Object.values(sites), ['order'], ['desc']);

  return (
    <Grid container spacing={2} className={classes.container}>
      {orderedSites.map(site => (
        <Grid item key={site.id} xs={6} sm={4} md={3}>
          <SiteCard
            business={business}
            site={site}
          />
        </Grid>
      ))}
    </Grid>
  );
}

Sites.propTypes = {
  business: PropTypes.object,
  sites: PropTypes.arrayOf(PropTypes.object)
}

export default Sites;